import { memo } from 'react';
import { Tooltip } from '@mui/material';
import AIDetectionOffIcon from 'assets/icons/CameraStream/AIDetectionOffIcon';

import PropTypes from 'prop-types';

import styles from './AIDetection.module.css';

const AIDetection = ({ isDetectionOn, className = '' }) => {
    const detectionOffElement = (
        <span className={styles['detection-off--wrapper']}>
            <AIDetectionOffIcon className={styles['detection-off--icon']} />
            <p>Detection is OFF</p>
        </span>
    );

    return (
        <Tooltip title={isDetectionOn ? 'AI Detection is ON' : 'AI Detection is OFF. Please monitor it closely.'} placement="top">
            <span className={`${styles['ai-detection--wrapper']} ${className}`}>{!isDetectionOn && detectionOffElement}</span>
        </Tooltip>
    );
};

AIDetection.propTypes = {
    isDetectionOn: PropTypes.bool,
    isSideBarPanel: PropTypes.bool,
    className: PropTypes.string,
};

export default memo(AIDetection);
